import { Routes } from '@angular/router';
import { authGuard, loginGuard } from './guards/auth.guard';
import { featureGuard } from './guards/feature.guard';
import { roleGuard } from './guards/role.guard';
import { trocaSenhaGuard } from './guards/troca-senha.guard';
import { LayoutComponent } from './pages/layout/layout.component/layout.component';
import { LoginComponent } from './pages/login/login.component';

export const routes: Routes = [
  { path: 'login', component: LoginComponent, canActivate: [loginGuard] },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [authGuard],
    canActivateChild: [trocaSenhaGuard],
    children: [
      {
        path: 'home',
        loadComponent: () => import('./pages/home/home.component').then((m) => m.HomeComponent),
      },
      {
        path: 'clientes',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./pages/clientes/cliente-lista.component/cliente-lista.component').then(
                (m) => m.ClienteListaComponent,
              ),
          },
          {
            path: 'novo',
            canActivate: [roleGuard('ADMIN')],
            loadComponent: () =>
              import('./pages/clientes/cliente-form.component/cliente-form.component').then(
                (m) => m.ClienteFormComponent,
              ),
          },
          {
            path: ':id/editar',
            canActivate: [roleGuard('ADMIN')],
            loadComponent: () =>
              import('./pages/clientes/cliente-form.component/cliente-form.component').then(
                (m) => m.ClienteFormComponent,
              ),
          },
          {
            path: ':id',
            loadComponent: () =>
              import('./pages/clientes/cliente-detalhe.component/cliente-detalhe.component').then(
                (m) => m.ClienteDetalheComponent,
              ),
          },
        ],
      },
      {
        path: 'servidores',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./pages/servidores/servidor-lista.component/servidor-lista.component').then(
                (m) => m.ServidorListaComponent,
              ),
          },
          {
            path: 'novo',
            canActivate: [roleGuard('ADMIN')],
            loadComponent: () =>
              import('./pages/servidores/servidor-form.component/servidor-form.component').then(
                (m) => m.ServidorFormComponent,
              ),
          },
          {
            path: ':id/editar',
            canActivate: [roleGuard('ADMIN')],
            loadComponent: () =>
              import('./pages/servidores/servidor-form.component/servidor-form.component').then(
                (m) => m.ServidorFormComponent,
              ),
          },
          {
            path: ':id',
            loadComponent: () =>
              import(
                './pages/servidores/servidor-detalhe.component/servidor-detalhe.component'
              ).then((m) => m.ServidorDetalheComponent),
          },
        ],
      },
      {
        path: 'monitoramento',
        loadComponent: () =>
          import('./pages/monitoramento/monitoramento.component/monitoramento.component').then(
            (m) => m.MonitoramentoComponent,
          ),
      },
      {
        path: 'auditoria',
        canActivate: [roleGuard('ADMIN')],
        loadComponent: () =>
          import('./pages/auditoria/auditoria.component/auditoria.component').then(
            (m) => m.AuditoriaComponent,
          ),
      },
      {
        path: 'logins',
        loadComponent: () =>
          import('./pages/logins/logins.component/logins.component').then(
            (m) => m.LoginsComponent,
          ),
      },
      {
        path: 'usuarios',
        children: [
          {
            path: '',
            canActivate: [roleGuard('ADMIN')],
            loadComponent: () =>
              import('./pages/usuarios/usuario-lista.component/usuario-lista.component').then(
                (m) => m.UsuarioListaComponent,
              ),
          },
          {
            path: 'novo',
            canActivate: [roleGuard('ADMIN')],
            loadComponent: () =>
              import('./pages/usuarios/usuario-form.component/usuario-form.component').then(
                (m) => m.UsuarioFormComponent,
              ),
          },
          {
            path: ':id/editar',
            canActivate: [roleGuard('ADMIN')],
            loadComponent: () =>
              import('./pages/usuarios/usuario-form.component/usuario-form.component').then(
                (m) => m.UsuarioFormComponent,
              ),
          },
        ],
      },
      {
        path: 'conta/senha',
        loadComponent: () =>
          import('./pages/conta/conta-senha.component/conta-senha.component').then(
            (m) => m.ContaSenhaComponent,
          ),
      },
      {
        path: 'versoes',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./pages/versoes/versao-lista.component/versao-lista.component').then(
                (m) => m.VersaoListaComponent,
              ),
          },
          {
            path: 'novo',
            canActivate: [roleGuard('ADMIN')],
            loadComponent: () =>
              import('./pages/versoes/versao-form.component/versao-form.component').then(
                (m) => m.VersaoFormComponent,
              ),
          },
          {
            path: ':id/editar',
            canActivate: [roleGuard('ADMIN')],
            loadComponent: () =>
              import('./pages/versoes/versao-form.component/versao-form.component').then(
                (m) => m.VersaoFormComponent,
              ),
          },
        ],
      },
      {
        path: 'tenants',
        canActivate: [featureGuard('tenants')],
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./pages/tenants/tenant-lista.component/tenant-lista.component').then(
                (m) => m.TenantListaComponent,
              ),
          },
          {
            path: 'novo',
            canActivate: [roleGuard('ADMIN')],
            loadComponent: () =>
              import('./pages/tenants/tenant-form.component/tenant-form.component').then(
                (m) => m.TenantFormComponent,
              ),
          },
          {
            path: ':id/editar',
            canActivate: [roleGuard('ADMIN')],
            loadComponent: () =>
              import('./pages/tenants/tenant-form.component/tenant-form.component').then(
                (m) => m.TenantFormComponent,
              ),
          },
          {
            path: ':id',
            loadComponent: () =>
              import('./pages/tenants/tenant-detalhe.component/tenant-detalhe.component').then(
                (m) => m.TenantDetalheComponent,
              ),
          },
        ],
      },
      {
        path: 'migracoes',
        canActivate: [featureGuard('tenants')],
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./pages/migracoes/migracao-lista.component/migracao-lista.component').then(
                (m) => m.MigracaoListaComponent,
              ),
          },
          {
            path: 'nova',
            canActivate: [roleGuard('ADMIN')],
            loadComponent: () =>
              import('./pages/migracoes/migracao-form.component/migracao-form.component').then(
                (m) => m.MigracaoFormComponent,
              ),
          },
          {
            path: ':id',
            loadComponent: () =>
              import(
                './pages/migracoes/migracao-detalhe.component/migracao-detalhe.component'
              ).then((m) => m.MigracaoDetalheComponent),
          },
        ],
      },
      // Novas telas entram aqui como filhas lazy (roleGuard('ADMIN') para Usuários e Auditoria).
      { path: '', redirectTo: 'home', pathMatch: 'full' },
      { path: '**', redirectTo: 'home' },
    ],
  },
];
